import gql from 'graphql-tag';

export const UPDATE_APPLICATION_ITEM = gql`
  mutation (
    $id: String!
    $updateId: String!
    $input: UpdateApplicationItemInput!
  ) {
    updateApplicationItem(id: $id, updateId: $updateId, input: $input) {
      _id
    }
  }
`;
